const Forbidden = () => {
    return (
        <div>Bu sayfaya/bölgeye erişiminiz bulunmamaktadır. </div>
      )
};

export default Forbidden;
